$(function () {
    $('.leaflet-draw-toolbar a').click(function () {
        var this1 = $(this).position().left;
        $('.leaflet-draw-actions').css('left', this1);
    });
    // $('.leaflet-draw-draw-locationlat').on('click', function () { 
    //     $('.latLongContainer').toggleClass('lat-l-dblock'); 
    //    var x = event.clientX;
    //     console.log(x)
    //    $('.latLongContainer').css('left', x )
    // });
    // $(window).ready(function () {
    //     /*var buttonex = '<a class="leaflet-draw-draw-export" id="export" onclick="MapHandler.SaveGeojson();" title="Export ShapeFile"><span class="sr-only">Export ShapeFile</span></a>'
    //     $('.leaflet-draw-toolbar.leaflet-draw-toolbar-top').append(buttonex);
    //     });*/
    //     var routeRefresh = '<a id="routeRefresh" title="Clear Route" > <span class="material-icons large">gps_off</span></a>';
    //     var homepanel = '<a id="home_panel_trigger" title="Home" > <span class="material-icons">home</span></a>';
    //     var addid = document.getElementsByClassName("leaflet-draw-toolbar leaflet-bar");
    //     addid[1].classList.add("savedraw");
    //     var buttonex = '<a class="material-icons" id="export" onclick="MapHandler.SaveGeojson();" title="Export ShapeFile"><i class="material-icons" style="margin-top: 9px;margin-right: 3px;margin-bottom: 0px;margin-left: 9px;">save</i></a>'
    //     var fileupload = '<a class="material-icons" id="export" onclick="fileuploadpopup();" title="Export ShapeFile"><i class="material-icons" style="margin-top: 9px;margin-right: 3px;margin-bottom: 0px;margin-left: 9px;">backup</i></a>'
    //     $('.leaflet-draw-toolbar.leaflet-bar.savedraw').append(buttonex);
    //     $('.leaflet-draw-toolbar.leaflet-bar.savedraw').append(fileupload);
    //     $('.leaflet-control-zoom').prepend('<a class="leaflet-draw-draw-locationlat" id="locationLat-lg" title="Search Lat/Lon"><span></span></a>');

    //     $('.leaflet-control-zoom').prepend(homepanel);
    //     $('.leaflet-control-zoom').prepend(routeRefresh);
    //     $(document).on("click", "#home_panel_trigger", function () { MapHandler.map.setView([23.10, 78.10], 5); });


    //     $(document).on("click", "#routeRefresh", function () { clearRoute(); });


    //     // $('#layer_panel_trigger').on('click', function() {$('#layer_panel_sec').toggleClass('showLayers');});

    //     $('#layer_panel_close').on('click', function () { $('#layer_panel_sec').toggleClass('showLayers'); })

    //     $('.tablecloseBox').click(function () { $('.bottomatablearea').removeClass('showtable'); });
    // });

    // $("#toc").draggable({
    //     handle: ".load_box"
    // });


    // var layerpanel = '<a id="layer_panel_trigger" title="Basemap" > <span class="material-icons">layers</span></a>';
    // var routeRefresh = '<a id="routeRefresh" title="Clear Route" > <span class="material-icons large">gps_off</span></a>';
    // var homepanel = '<a id="home_panel_trigger" title="Home" > <span class="material-icons">home</span></a>';

    // $(document).on("click", "#home_panel_trigger", function () { MapHandler.map.setView([23.10, 78.10], 5); });


    // $(document).on("click", "#routeRefresh", function () { clearRoute(); });

    // $('.leaflet-control-zoom').append(layerpanel);

    // $('.leaflet-control-zoom').prepend('<a class="leaflet-draw-draw-locationlat" id="locationLat-lg" title="Search Lat/Lon"><span></span></a>');

    // $('.leaflet-control-zoom').prepend(homepanel);
    // $('.leaflet-control-zoom').prepend(routeRefresh);
    //$('.leaflet-draw-draw-locationlat').on('click', function () { $('.latLongContainer').toggleClass('lat-l-dblock'); });

    // $('#layer_panel_trigger').on('click', function() {$('#layer_panel_sec').toggleClass('showLayers');});

    // $('#layer_panel_close').on('click', function () { $('#layer_panel_sec').toggleClass('showLayers'); })

    // $('.tablecloseBox').click(function () { $('.bottomatablearea').removeClass('showtable'); });
})